export const weglotScriptSrc = "https://cdn.weglot.com/weglot.min.js";
export const DEFAULT_LANG_OBJ = { key: "en", label: "English" };
export const WEGLOT_LANG = "wglang";
/** When present as `true`, opt in to cookie-synced language routing (higher Weglot API usage). */
export const FORCE_TRANSLATIONS_QUERY_PARAM = "f_t";
